import React from 'react';
import { ArrowRight, Zap, Gift, Clock, ChevronDown, Star } from 'lucide-react';
import { laverieInfo, heroImage } from '../data/mock';
import BasqueFlag from './BasqueFlag';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Lavoir des Remparts"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/60" />
        {/* Subtle pattern overlay */}
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }} />
      </div>
      
      {/* Content */}
      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 pt-32 pb-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-md text-white px-5 py-2.5 rounded-full mb-8 border border-white/20 animate-fade-in-up">
            <BasqueFlag size={24} />
            <span className="font-semibold">Votre laverie au cœur de Bayonne</span>
            <Star size={14} className="text-[#9B1B30]" />
          </div>

          {/* Title */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[1.1] mb-8">
            Votre linge
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#9B1B30] via-[#ff4d6d] to-[#9B1B30]">
              propre en 1h
            </span>
          </h1>

          {/* Subtitle with commercial highlight */}
          <p className="text-lg md:text-xl text-white/80 leading-relaxed mb-10 max-w-2xl">
            Machines professionnelles dernière génération.
            <span className="block mt-2 text-white font-semibold">
              ✨ Lessive & Adoucissant <span className="text-[#9B1B30]">OFFERTS</span> • Tarifs pros jusqu'à <span className="text-[#9B1B30]">-30%</span>
            </span>
          </p>

          {/* Key advantages - Commercial focus */}
          <div className="flex flex-wrap gap-3 mb-10">
            {[
              { icon: Clock, text: 'Linge prêt en 1h', highlight: true },
              { icon: Gift, text: 'Lessive & Adoucissant OFFERTS', highlight: true },
              { icon: Zap, text: 'Pros : -30%', highlight: false }
            ].map((item, i) => (
              <div 
                key={i} 
                className={`flex items-center gap-2.5 px-5 py-3 rounded-full border transition-all hover:scale-105 ${
                  item.highlight 
                    ? 'bg-[#9B1B30]/20 border-[#9B1B30]/50 text-white' 
                    : 'bg-white/10 backdrop-blur-sm border-white/20 text-white/90'
                }`}
              >
                <item.icon size={18} className={item.highlight ? 'text-[#9B1B30]' : 'text-white/70'} />
                <span className="font-semibold">{item.text}</span>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#galerie"
              className="group inline-flex items-center justify-center gap-3 bg-[#9B1B30] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#B91C3B] transition-all shadow-lg hover:shadow-2xl hover:shadow-[#9B1B30]/30 hover:scale-105"
            >
              Découvrir la laverie
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#tarifs"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-md text-white px-8 py-4 rounded-full font-bold text-lg border border-white/30 hover:bg-white/20 transition-all hover:scale-105"
            >
              Voir les tarifs
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator - Centered */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center">
        <a 
          href="#services" 
          className="flex flex-col items-center text-white/60 hover:text-white transition-colors animate-bounce"
        >
          <span className="text-sm font-medium mb-2">Découvrir</span>
          <ChevronDown size={28} />
        </a>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/4 right-10 w-64 h-64 bg-[#9B1B30]/20 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-48 h-48 bg-[#006633]/20 rounded-full blur-3xl" />
    </section>
  );
};

export default Hero;
